import React from 'react';
import {ZoomControl} from "react-leaflet";
import GeoJSONMap from "../../../../components/maps/GeoJSONMap";
import ButtonBase from "@mui/material/ButtonBase";
import Icon from "@mui/material/Icon";
import StationsLayer from "./StationsLayer";
import MicroZonesLayer from "./MicroZonesLayer";
import Models23Layer from "./Models23Layer";
import Models1Layer from "./Models1Layer";
import IncidentsLayer from "./IncidentsLayer";
import LegendControl from "./LegendControl";

const POSITION_CLASSES = {
    bottomleft: 'leaflet-bottom leaflet-left',
    bottomright: 'leaflet-bottom leaflet-right',
    topleft: 'leaflet-top leaflet-left',
    topright: 'leaflet-top leaflet-right',
}

const WebgisMap = ({mapRef, webgis}) => {
    const {layersState, featuresState, filterPanel, dataPanel} = webgis;
    const onFilterToggle = filterPanel.toggle;
    const filterPanelIsOpen = filterPanel.isOpen ?? false;
    const onTablesToggle = dataPanel.toggleTables;

    const {layers} = layersState;
    const { incidentSettingQuery } = featuresState;

    return <GeoJSONMap mapRef={mapRef}
                       center={[45.5, 10]}
                       zoom={8}
                       data={[]}
                       zoomControl={false}>
        <div className={POSITION_CLASSES.topleft}>
            <div className="leaflet-control-container">
                <div className="leaflet-control leaflet-control-layers">
                    <ButtonBase onClick={onFilterToggle}
                                sx={{width: 42, height: 42}}>
                        <Icon fontSize="14px">{filterPanelIsOpen ? 'left_panel_close' : 'left_panel_open'}</Icon>
                    </ButtonBase>
                </div>
            </div>
        </div>

        <div className={POSITION_CLASSES.topright}>
            <div className="leaflet-control-container">
                <div className="leaflet-control leaflet-control-layers">
                    <ButtonBase onClick={onTablesToggle}
                                sx={{width: 42, height: 42}}>
                        <Icon fontSize="14px">table_view</Icon>
                    </ButtonBase>
                </div>
            </div>
        </div>

        <div className={POSITION_CLASSES.bottomright} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px', paddingBottom: '18px', paddingRight: '50px'}}>
            <LegendControl webgis={webgis} />
            <ZoomControl position="bottomright"/>
        </div>

        {
            incidentSettingQuery.isLoading ? null :
                <>
                    {
                        layers.stations.active && <StationsLayer webgis={webgis} />
                    }
                    {
                        layers.microzones.active && <MicroZonesLayer webgis={webgis} />
                    }
                    {
                        layers.models23.active && <Models23Layer webgis={webgis} />
                    }
                    {
                        layers.model1Stations.active && <Models1Layer webgis={webgis} />
                    }
                    {
                        layers.incidents.active && <IncidentsLayer webgis={webgis}/>
                    }
                </>
        }
    </GeoJSONMap>
}

export default WebgisMap;